import React from 'react';
import { Typography, Image } from 'lib/components';
import { JobFile } from 'types';
import { useWindowResize } from 'hooks/useWindowResize';
import classes from './index.module.scss';

/**
 * Props interface for the FileDownload component
 */
interface Props {
	/** Job file object containing file metadata and path */
	file: JobFile;
}

/**
 * FileDownload component
 * Renders a downloadable file link with the file name and a download icon
 * Adapts typography size based on device screen size
 *
 * @param {Props} props - Component props
 * @returns {JSX.Element} - Rendered component
 */
const FileDownload = ({ file }: Props) => {
	// Get device size information for responsive design
	const { isSmallerDevice } = useWindowResize();

	return (
		<a
			href={file.path}
			download
			className={classes['file-container']}
			style={{
				width: '20rem',
				justifyContent: 'space-between',
			}}
		>
			<div style={{ display: 'flex' }}>
				{/* Adjust typography size based on device size */}
				<Typography variant={isSmallerDevice ? 'h5' : 'h6'}>Download -</Typography>
				<Typography variant={isSmallerDevice ? 'h5' : 'h6'} color="gray" style={{ marginLeft: '0.2rem' }}>
					{file.name}
				</Typography>
			</div>
			{/* Download icon */}
			<Image src="icDownloadPrimary" />
		</a>
	);
};

export default FileDownload;
